import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "SettingCell__dot rounded-circle bg-space-b-70"
}
const _hoisted_2 = {
  key: 1,
  class: "SettingCell__dot"
}
const _hoisted_3 = { class: "row items-center q-mx-12" }

import { reactive, toValue, computed, ref } from 'vue'

interface IProps {
  page: number
  icon: string
  title: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'SettingCell' },
  __name: 'SettingCell',
  props: /*@__PURE__*/_mergeModels({
    page: {},
    icon: {},
    title: {}
  }, {
    "modelValue": { type: Number, required: true },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {


const model = _useModel(__props, "modelValue")
const props = __props

const state = reactive(toValue(() => props))
const isActive = computed(() => model.value === props.page)
const iconColorRef = ref('cool-gray-70')
const titleColorRef = ref('text-cool-gray-70')

function setHoverStyle() {
  iconColorRef.value = 'space-b-100'
  titleColorRef.value = 'text-cool-gray-100'
}

function removeHoverStyle() {
  iconColorRef.value = 'cool-gray-70'
  titleColorRef.value = 'text-cool-gray-70'
}

return (_ctx: any,_cache: any) => {
  const _component_k_icon = _resolveComponent("k-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["SettingCell row items-center cursor-pointer q-px-12 q-py-sm q-my-md", isActive.value && 'bg-white rounded-8']),
    onMouseover: setHoverStyle,
    onMouseleave: removeHoverStyle
  }, [
    (isActive.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : (_openBlock(), _createElementBlock("div", _hoisted_2)),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_k_icon, {
        name: state.icon,
        color: isActive.value ? 'cool-gray-100' : iconColorRef.value
      }, null, 8 /* PROPS */, ["name", "color"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["SettingCell__title fs-15px fw-500", isActive.value ? 'text-cool-gray-100' : titleColorRef.value])
    }, _toDisplayString(state.title), 3 /* TEXT, CLASS */)
  ], 34 /* CLASS, NEED_HYDRATION */))
}
}

})